<!-- Shared two-card toggle for choosing between 'leftovers' and 'repeat' portions mode.
     Usage: <PortionsModeToggle v-model="portionsMode" /> -->
<script setup lang="ts">
defineProps<{ modelValue: 'leftovers' | 'repeat' }>()
defineEmits<{ 'update:modelValue': [value: 'leftovers' | 'repeat'] }>()
</script>

<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">

    <!-- Cooked Once -->
    <button type="button" @click="$emit('update:modelValue', 'leftovers')"
      class="portions-card" :class="{ 'portions-card--active': modelValue === 'leftovers' }">
      <svg class="portions-card-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z" />
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1.001A3.75 3.75 0 0012 18z" />
      </svg>
      <span class="portions-card-title">Cooked Once</span>
      <span class="portions-card-desc">Cook it once and it covers all selected days. Ingredients are counted once in your shopping list.</span>
    </button>

    <!-- Cook fresh each day -->
    <button type="button" @click="$emit('update:modelValue', 'repeat')"
      class="portions-card" :class="{ 'portions-card--active': modelValue === 'repeat' }">
      <svg class="portions-card-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
      </svg>
      <span class="portions-card-title">Cook fresh each day</span>
      <span class="portions-card-desc">The recipe is made separately on each day. Ingredients are multiplied by the number of days.</span>
    </button>

  </div>
</template>

<style scoped>
.portions-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 14px;
  border-radius: 10px;
  border: 2px solid #E2E8F0;
  background: #F8FAFC;
  cursor: pointer;
  text-align: left;
  transition: border-color 150ms ease, background 150ms ease;
}
.portions-card:hover       { border-color: #B4CBB0; background: #F0F7EF; }
.portions-card--active     { border-color: #4F8646; background: #EAF1EB; }

.portions-card-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: #94A3B8;
}
.portions-card--active .portions-card-icon { color: #4F8646; }

.portions-card-title {
  font-size: 13px;
  font-weight: 700;
  color: #0F172A;
}
.portions-card--active .portions-card-title { color: #2d5a26; }

.portions-card-desc {
  font-size: 11px;
  font-weight: 400;
  color: #64748B;
  line-height: 1.4;
}
</style>
